import {
  AtmCardIcon,
  CalendarIcon,
  CheckIcon,
  EditContentIcon,
  MailSendEnvelopeIcon,
  UserSingleIcon,
} from '@calendly/ui/components/icons'

import { useI18n } from 'locales'

import {
  PhonePaymentSuccessContainer,
  PhonePaymentSuccessIcon,
  PhonePaymentSuccessTitle,
  PhonePaymentSuccessTitleGroup,
  PhonePaymentSuccessDescription,
  PhonePaymentSuccessDetails,
  PhonePaymentSuccessDetailRow,
  PhonePaymentSuccessDetailText,
  PhonePaymentSuccessConfirmation,
  PhonePaymentSuccessDownloadButton,
} from './styles'

const InvoiceMobilePaidSuccess = ({
  invoice,
  amountDueValue,
  paidAtFormatted,
  onDownloadInvoice,
}) => {
  const { i18n } = useI18n()

  return (
    <PhonePaymentSuccessContainer>
      <PhonePaymentSuccessIcon>
        <CheckIcon size="large" aria-hidden />
      </PhonePaymentSuccessIcon>
      <PhonePaymentSuccessTitleGroup>
        <PhonePaymentSuccessTitle>
          {i18n.t('booking.invoice.payment_received')}
        </PhonePaymentSuccessTitle>
        <PhonePaymentSuccessDescription>
          {i18n.t('booking.invoice.payment_received_description', {
            invoice_number: invoice.invoice_number,
          })}
        </PhonePaymentSuccessDescription>
      </PhonePaymentSuccessTitleGroup>
      <PhonePaymentSuccessDetails>
        <PhonePaymentSuccessDetailRow>
          <AtmCardIcon size="standard" aria-hidden />
          <PhonePaymentSuccessDetailText>
            {i18n.t('booking.invoice.amount_paid_line', { amount: amountDueValue })}
          </PhonePaymentSuccessDetailText>
        </PhonePaymentSuccessDetailRow>
        <PhonePaymentSuccessDetailRow>
          <EditContentIcon size="standard" aria-hidden />
          <PhonePaymentSuccessDetailText>
            {i18n.t('booking.invoice.invoice_number', {
              invoice_number: invoice.invoice_number,
            })}
          </PhonePaymentSuccessDetailText>
        </PhonePaymentSuccessDetailRow>
        <PhonePaymentSuccessDetailRow>
          <CalendarIcon size="standard" aria-hidden />
          <PhonePaymentSuccessDetailText>
            {i18n.t('booking.invoice.paid_on', { date: paidAtFormatted })}
          </PhonePaymentSuccessDetailText>
        </PhonePaymentSuccessDetailRow>
        {invoice?.contact?.full_name ? (
          <PhonePaymentSuccessDetailRow>
            <UserSingleIcon size="standard" aria-hidden />
            <PhonePaymentSuccessDetailText>
              {invoice.contact.full_name}
            </PhonePaymentSuccessDetailText>
          </PhonePaymentSuccessDetailRow>
        ) : null}
        {invoice?.contact?.primary_email ? (
          <PhonePaymentSuccessDetailRow>
            <MailSendEnvelopeIcon size="standard" aria-hidden />
            <PhonePaymentSuccessDetailText>
              {invoice.contact.primary_email}
            </PhonePaymentSuccessDetailText>
          </PhonePaymentSuccessDetailRow>
        ) : null}
      </PhonePaymentSuccessDetails>
      <PhonePaymentSuccessConfirmation>
        {i18n.t('booking.invoice.payment_received_confirmation')}
      </PhonePaymentSuccessConfirmation>
      <PhonePaymentSuccessDownloadButton wide onClick={onDownloadInvoice}>
        {i18n.t('booking.invoice.download_invoice')}
      </PhonePaymentSuccessDownloadButton>
    </PhonePaymentSuccessContainer>
  )
}

export default InvoiceMobilePaidSuccess
